import { switchMap, filter, takeUntil, map, withLatestFrom } from 'rxjs/operators';
import { interval, EMPTY } from 'rxjs';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { isMatchedPathnameSelector } from '@cbridge-packages/routing';
import { RouteSegments } from '@cbridge-packages/routing-client-admin';
import { isAlertsPollingEnabledSelector } from '../_selectors/isAlertsPollingEnabled.selector';
import { ALERTS_POLLING_INTERVAL } from '../alertsDashboard.constans';
import { AlertsDashboardAction } from '../alertsDashboard.action';

type IState =
  IGetSelectorStateType<typeof isAlertsPollingEnabledSelector>
  & IGetSelectorStateType<typeof isMatchedPathnameSelector>;

const ALERTS_ROUTE_PATTERN = `/${RouteSegments.Root.Dashboard}/${RouteSegments.Dashboards.Alerts}`;

export const pollingDashboardAlertsEpic: IEpic<IState> = (action$, state$) => {
  return action$.pipe(
    isTypeOf(AlertsDashboardAction.togglePolling, AlertsDashboardAction.setPollingEnabled),
    switchMap(() => {
      const currentState = state$.value;
      const isEnabled = isAlertsPollingEnabledSelector(currentState);

      if (!isEnabled) {
        return EMPTY;
      }

      return interval(ALERTS_POLLING_INTERVAL).pipe(
        withLatestFrom(state$),
        filter(([, state]) => {
          const isOnAlertsRoute = isMatchedPathnameSelector(state, { pattern: ALERTS_ROUTE_PATTERN });
          const currentAutoLoading = isAlertsPollingEnabledSelector(state);
          return isOnAlertsRoute && currentAutoLoading;
        }),
        map(() => AlertsDashboardAction.getNextPage()),
        takeUntil(
          action$.pipe(
            isTypeOf(
              AlertsDashboardAction.togglePolling,
              AlertsDashboardAction.setPollingEnabled,
              AlertsDashboardAction.destroy,
            ),
            withLatestFrom(state$),
            filter(([, state]) => {
              const currentAutoLoading = isAlertsPollingEnabledSelector(state);
              return !currentAutoLoading;
            }),
          ),
        ),
      );
    }),
  );
};
